// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.chat__list[data-v-91ef4d8e] {
  width: 100%;
  list-style: none;
  padding: 0 30px;
  margin: 0 0 10px 0;
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}
.chat__grid .chat__inneritems[data-v-91ef4d8e],
.chat__list .chat__inneritems[data-v-91ef4d8e] {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.fullfill__columns[data-v-91ef4d8e] {
  display: inline-block;
  margin: 0;
  width: 100%;
}
.fullfill__columns .chat__grid[data-v-91ef4d8e] {
  width: 100%;
  list-style: none;
  padding: 0 30px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.chat__grid.last_full_width .chat__inneritems[data-v-91ef4d8e]:last-of-type {
  grid-column: 1 / -1;
}
.img-max-height[data-v-91ef4d8e] {
  margin-bottom: 4px;
  height: 28px;
}
.chatbot-response .text-white[data-v-91ef4d8e] {
  color: #fff !important;
}
.chat__body__btn[data-v-91ef4d8e] {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  padding: 0;
  border: 0 !important;
  background: none !important;
  outline: 0 !important;
  cursor: pointer;
  height: 100%;
  text-align: center;
}
.icon__cont__box[data-v-91ef4d8e] {
  margin-bottom: 5px;
  margin-right: 0;
  border: 0;
  padding: 2px;
  display: flex;
}
.chat__list .chat__inneritems .chat__body__btn[data-v-91ef4d8e] {
  flex-direction: row;
  justify-content: flex-start;
}
.chat__list .chat__inneritems .icon__cont__box[data-v-91ef4d8e] {
  margin: 0 10px 0 0;
  display: flex;
}
.chat__list .chat__inneritems .icon__cont__box .icon__cont[data-v-91ef4d8e] {
  font-size: 18px;
}
.chat__grid .chat__inneritems .icon__cont__box .icon__cont[data-v-91ef4d8e] {
  font-size: 18px;
}
.chat__list .chat__inneritems .icon__cont__box .end__chatIcon[data-v-91ef4d8e] {
  width: 20px;
  height: auto;
}
.chat__grid .chat__inneritems .icon__cont__box .end__chatIcon[data-v-91ef4d8e] {
  width: 20px;
  height: auto;
}
.chat__list .chat__inneritems .icon__cont__box .end__chatIcon path[data-v-91ef4d8e],
.chat__grid .chat__inneritems .icon__cont__box .end__chatIcon path[data-v-91ef4d8e] {
  color: var(--color-primary);
  fill: currentColor;
}
.chat__body__btn__title[data-v-91ef4d8e] {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: #000;
}
.custom-payload-con[data-v-91ef4d8e] {
  width: 100%;
  /* border: 1px solid #eee; */
  border-radius: 6px;
  padding: 13px 2px;
  height: 100%;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.09);
}
.chat__list .chat__inneritems .custom-payload-con[data-v-91ef4d8e] {
  padding: 10px 15px;
  border-radius: 5px;
}
.chat__body__btn em[data-v-91ef4d8e] {
  font-size: 27px;
  margin-bottom: 3px;
}
@media all and (min-width: 1900px) {
.chat__list .chat__inneritems .custom-payload-con[data-v-91ef4d8e] {
    padding: 15px 30px;
    border-radius: 10px;
}
}
@media all and (min-width: 2500px) {
.chat__list .chat__inneritems .custom-payload-con[data-v-91ef4d8e] {
    padding: 20px 30px;
    border-radius: 12px;
}
.chat__body__btn em[data-v-91ef4d8e] {
    font-size: 35px;
}
.chat__body__btn em.customfontsize[data-v-91ef4d8e] {
    font-size: 40px !important;
}
}
@media all and (min-width: 3800px) {
.chat__list .chat__inneritems .custom-payload-con[data-v-91ef4d8e] {
    padding: 40px 50px;
    border-radius: 15px;
}
.chat__body__btn em[data-v-91ef4d8e] {
    font-size: 35px;
}
.chat__body__btn em.customfontsize[data-v-91ef4d8e] {
    font-size: 40px !important;
}
}
@media all and (min-width: 1900px) {
#chatBodySec2 .chat__body__btn__title[data-v-91ef4d8e] {
    font-size: 13px;
}
#chatBodySec2 .chat__grid .chat__inneritems .chat__body__btn__title[data-v-91ef4d8e] {
    font-size: 14px;
}
.chat__list .chat__inneritems .chat__body__btn[data-v-91ef4d8e] {
    min-height: 40px;
}
.chat__list .chat__inneritems .icon__cont__box[data-v-91ef4d8e] {
    margin: 0 20px 0 0;
}
.chat__list .chat__inneritems .icon__cont__box .icon__cont[data-v-91ef4d8e] {
    font-size: 24px;
}
.chat__list .chat__inneritems .icon__cont__box .end__chatIcon[data-v-91ef4d8e] {
    width: 24px;
}
#chatBodySec2 .chat__list .chat__inneritems .chat__body__btn__title[data-v-91ef4d8e] {
    font-size: 16px;
}
.chat__grid .chat__inneritems .icon__cont__box .icon__cont[data-v-91ef4d8e] {
    font-size: 22px;
}
.chat__grid .chat__inneritems .icon__cont__box .end__chatIcon[data-v-91ef4d8e] {
    width: 22px;
}
.img-max-height[data-v-91ef4d8e] {
    height: 35px;
}
.fullfill__columns .chat__grid[data-v-91ef4d8e] {
    gap: 15px;
}
}
@media all and (min-width: 2500px) {
#chatBodySec2 .chat__body__btn__title[data-v-91ef4d8e] {
    font-size: 18px;
}
#chatBodySec2 .chat__grid .chat__inneritems .chat__body__btn__title[data-v-91ef4d8e] {
    font-size: 20px;
}
.chat__grid .chat__inneritems .chat__body__btn[data-v-91ef4d8e] {
    min-height: 100px;
}
.chat__list .chat__inneritems .chat__body__btn[data-v-91ef4d8e] {
    min-height: 50px;
}
.chat__list .chat__inneritems .icon__cont__box[data-v-91ef4d8e] {
    margin: 0 20px 0 0;
}
.chat__list .chat__inneritems .icon__cont__box .icon__cont[data-v-91ef4d8e] {
    font-size: 36px;
}
.chat__list .chat__inneritems .icon__cont__box .end__chatIcon[data-v-91ef4d8e] {
    width: 36px;
}
#chatBodySec2 .chat__list .chat__inneritems .chat__body__btn__title[data-v-91ef4d8e] {
    font-size: 20px;
}
.chat__grid .chat__inneritems .icon__cont__box .icon__cont[data-v-91ef4d8e] {
    font-size: 28px;
}
.chat__grid .chat__inneritems .icon__cont__box .end__chatIcon[data-v-91ef4d8e] {
    width: 28px;
}
.chat__body__btn em[data-v-91ef4d8e] {
    font-size: 35px;
}
.chat__body__btn em.customfontsize[data-v-91ef4d8e] {
    font-size: 40px !important;
}
}
@media all and (min-width: 3800px) {
#chatBodySec2 .chat__body__btn__title[data-v-91ef4d8e] {
    font-size: 24px;
}
#chatBodySec2 .chat__grid .chat__inneritems .chat__body__btn__title[data-v-91ef4d8e] {
    font-size: 30px;
}
.chat__grid .chat__inneritems .chat__body__btn[data-v-91ef4d8e] {
    min-height: 160px;
}
.chat__list .chat__inneritems .chat__body__btn[data-v-91ef4d8e] {
    min-height: 60px;
}
.chat__list .chat__inneritems .icon__cont__box[data-v-91ef4d8e] {
    margin: 0 30px 0 0;
}
.chat__list .chat__inneritems .icon__cont__box .icon__cont[data-v-91ef4d8e] {
    font-size: 42px;
}
.chat__list .chat__inneritems .icon__cont__box .end__chatIcon[data-v-91ef4d8e] {
    width: 42px;
}
#chatBodySec2 .chat__list .chat__inneritems .chat__body__btn__title[data-v-91ef4d8e] {
    font-size: 30px;
}
.chat__grid .chat__inneritems .icon__cont__box[data-v-91ef4d8e] {
    margin-bottom: 10px;
}
.chat__grid .chat__inneritems .icon__cont__box .icon__cont[data-v-91ef4d8e] {
    font-size: 42px;
}
.chat__grid .chat__inneritems .icon__cont__box .end__chatIcon[data-v-91ef4d8e] {
    width: 42px;
}
.chat__body__btn em[data-v-91ef4d8e] {
    font-size: 35px;
}
.chat__body__btn em.customfontsize[data-v-91ef4d8e] {
    font-size: 40px !important;
}
}
.text_us_option[data-v-91ef4d8e] {
  padding: 5px 30px 20px 30px;
}
.text_us_card[data-v-91ef4d8e] {
  /* border: 1px solid #eee; */
  border-radius: 5px;
  padding: 13px 10px;
  cursor: pointer;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.09);
}
.text_us_card img[data-v-91ef4d8e] {
  height: 34px;
}
.or_section[data-v-91ef4d8e] {
  margin-bottom: 5px;
}
.text_us_option span[data-v-91ef4d8e] {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}
.text_us_option .text_us_card span[data-v-91ef4d8e] {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
  display: block;
}
.text_us_option .or_section span[data-v-91ef4d8e] {
  font-size: 13px;
}
div[disabled=true][data-v-91ef4d8e] {
  opacity: 0.6;
  pointer-events: none;
}
@media all and (min-width: 1900px) {
.text_us_option span[data-v-91ef4d8e] {
    font-size: 14px;
    font-weight: 600;
    color: #000;
}
.text_us_card img[data-v-91ef4d8e] {
    height: 50px;
}
.text_us_option[data-v-91ef4d8e] {
    padding: 5px 30px 20px 30px;
}
.chat__grid .custom-payload-con[data-v-91ef4d8e] {
    padding: 15px 2px !important;
}
.text_us_card[data-v-91ef4d8e] {
    padding: 16px 10px;
}
.chat__body__btn em[data-v-91ef4d8e] {
    font-size: 27px;
    margin-bottom: 3px;
}
.chat__body__btn em.customfontsize[data-v-91ef4d8e] {
    font-size: 30px !important;
    margin-bottom: 3px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/TvmStartUpButtons/TvmStartUpButtons.vue"],"names":[],"mappings":";AA0DA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,WAAW;AACb;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,YAAY;EACZ,aAAa;AACf;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;AAEA;EACE,eAAe;AACjB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,WAAW;EACX,YAAY;AACd;AAEA;EACE,WAAW;EACX,YAAY;AACd;AAEA;;EAEE,2BAA2B;EAC3B,kBAAkB;AACpB;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,4CAA4C;AAC9C;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AAEA;AACE;IACE,kBAAkB;IAClB,mBAAmB;AACrB;AACF;AAEA;AACE;IACE,kBAAkB;IAClB,mBAAmB;AACrB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,0BAA0B;AAC5B;AACF;AAEA;AACE;IACE,kBAAkB;IAClB,mBAAmB;AACrB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,0BAA0B;AAC5B;AACF;AAEA;AACE;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,gBAAgB;AAClB;AAEA;IACE,kBAAkB;AACpB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,WAAW;AACb;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,WAAW;AACb;AAEA;IACE,YAAY;AACd;AAEA;IACE,SAAS;AACX;AACF;AAEA;AACE;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,iBAAiB;AACnB;AAEA;IACE,gBAAgB;AAClB;AAEA;IACE,kBAAkB;AACpB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,WAAW;AACb;AAEA;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,WAAW;AACb;AAEA;IACE,eAAe;AACjB;AAEA;IACE,0BAA0B;AAC5B;AACF;AAEA;AACE;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,iBAAiB;AACnB;AAEA;IACE,gBAAgB;AAClB;AAEA;IACE,kBAAkB;AACpB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,WAAW;AACb;AAEA;IACE,eAAe;AACjB;AAEA;IACE,mBAAmB;AACrB;AAEA;IACE,eAAe;AACjB;AAEA;IACE,WAAW;AACb;AAEA;IACE,eAAe;AACjB;AAEA;IACE,0BAA0B;AAC5B;AACF;AAEA;EACE,2BAA2B;AAC7B;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,4CAA4C;AAC9C;AAEA;EACE,YAAY;AACd;AAEA;EACE,kBAAkB;AACpB;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;AAEA;AACE;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;AACb;AAEA;IACE,YAAY;AACd;AAEA;IACE,2BAA2B;AAC7B;AAEA;IACE,4BAA4B;AAC9B;AAEA;IACE,kBAAkB;AACpB;AAEA;IACE,eAAe;IACf,kBAAkB;AACpB;AAEA;IACE,0BAA0B;IAC1B,kBAAkB;AACpB;AAEF","sourcesContent":["<template>\r\n  <div>\r\n    <div class=\"pt-3\">\r\n      <div v-if=\"isTextUsEnabled && !isLoadingApi && textUsWidgetPosition === 'top'\" class=\"text_us_option py-0\">\r\n        <div class=\"d-flex align-items-center text_us_card justify-content-center\"\r\n          @click.prevent=\"$emit('showTextUsForm', $event)\"\r\n          :style=\"{ borderColor: chatThemeSettings?.borderColor || '' }\">\r\n          <div>\r\n            <TextUsIcon :theme-color=\"chatThemeSettings?.borderColor\" />\r\n          </div>\r\n          <div class=\"ml-3\">\r\n            <span> {{ customizedFlowNameForTextUs }} </span>\r\n          </div>\r\n        </div>\r\n        <div class=\"text-center or_section\">\r\n          <span class=\"font-weight-light\">Or</span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div v-if=\"serviceButtons && serviceButtons.length\" class=\"fullfill__columns\">\r\n      <div :class=\"evenOrOddClass\">\r\n        <div v-for=\"(item, index) in serviceButtons\" :key=\"index\" class=\"chat__inneritems\">\r\n          <div class=\"custom-payload-con\" :style=\"{ borderColor: chatThemeSettings?.borderColor || '' }\">\r\n            <div :title=\"item.text\" class=\"chat__body__btn cursor-pointer\" :disabled=\"isWaitingForResponse\"\r\n              @click=\"onPayloadButtonClick($event, item)\">\r\n              <em\r\n                :class=\"['primaryicon-' + iconMap(item.image), item.icon == 'primaryicon-Sales-Special' ? 'customfontsize' : '']\"\r\n                :style=\"{ color: chatThemeSettings?.borderColor || '#878787' }\" />\r\n              <p class=\"chat__body__btn__title\">\r\n                {{ item.text }}\r\n              </p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div v-if=\"isTextUsEnabled && !isLoadingApi && (textUsWidgetPosition === 'bottom' || textUsWidgetPosition === null)\"\r\n      class=\"text_us_option\">\r\n      <div class=\"text-center or_section\">\r\n        <span class=\"font-weight-light\">Or</span>\r\n      </div>\r\n      <div class=\"d-flex align-items-center text_us_card justify-content-center\"\r\n        :style=\"{ borderColor: chatThemeSettings?.borderColor || '' }\" @click.prevent=\"$emit('showTextUsForm', $event)\">\r\n        <div>\r\n          <TextUsIcon :theme-color=\"chatThemeSettings?.borderColor\" />\r\n        </div>\r\n        <div class=\"ml-3\">\r\n          <span> {{ customizedFlowNameForTextUs }} </span>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div v-if=\"!isTextUsEnabled || textUsWidgetPosition === 'top'\" class=\"mb-4\" />\r\n\r\n  </div>\r\n</template>\r\n<script src=\"./TvmStartUpButtons.js\"></script>\r\n<style scoped>\r\n.chat__list {\r\n  width: 100%;\r\n  list-style: none;\r\n  padding: 0 30px;\r\n  margin: 0 0 10px 0;\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 10px;\r\n}\r\n\r\n.chat__grid .chat__inneritems,\r\n.chat__list .chat__inneritems {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.fullfill__columns {\r\n  display: inline-block;\r\n  margin: 0;\r\n  width: 100%;\r\n}\r\n\r\n.fullfill__columns .chat__grid {\r\n  width: 100%;\r\n  list-style: none;\r\n  padding: 0 30px;\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 10px;\r\n}\r\n\r\n.chat__grid.last_full_width .chat__inneritems:last-of-type {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.img-max-height {\r\n  margin-bottom: 4px;\r\n  height: 28px;\r\n}\r\n\r\n.chatbot-response .text-white {\r\n  color: #fff !important;\r\n}\r\n\r\n.chat__body__btn {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-bottom: 0;\r\n  padding: 0;\r\n  border: 0 !important;\r\n  background: none !important;\r\n  outline: 0 !important;\r\n  cursor: pointer;\r\n  height: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.icon__cont__box {\r\n  margin-bottom: 5px;\r\n  margin-right: 0;\r\n  border: 0;\r\n  padding: 2px;\r\n  display: flex;\r\n}\r\n\r\n.chat__list .chat__inneritems .chat__body__btn {\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.chat__list .chat__inneritems .icon__cont__box {\r\n  margin: 0 10px 0 0;\r\n  display: flex;\r\n}\r\n\r\n.chat__list .chat__inneritems .icon__cont__box .icon__cont {\r\n  font-size: 18px;\r\n}\r\n\r\n.chat__grid .chat__inneritems .icon__cont__box .icon__cont {\r\n  font-size: 18px;\r\n}\r\n\r\n.chat__list .chat__inneritems .icon__cont__box .end__chatIcon {\r\n  width: 20px;\r\n  height: auto;\r\n}\r\n\r\n.chat__grid .chat__inneritems .icon__cont__box .end__chatIcon {\r\n  width: 20px;\r\n  height: auto;\r\n}\r\n\r\n.chat__list .chat__inneritems .icon__cont__box .end__chatIcon path,\r\n.chat__grid .chat__inneritems .icon__cont__box .end__chatIcon path {\r\n  color: var(--color-primary);\r\n  fill: currentColor;\r\n}\r\n\r\n.chat__body__btn__title {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  margin: 0;\r\n  color: #000;\r\n}\r\n\r\n.custom-payload-con {\r\n  width: 100%;\r\n  /* border: 1px solid #eee; */\r\n  border-radius: 6px;\r\n  padding: 13px 2px;\r\n  height: 100%;\r\n  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.09);\r\n}\r\n\r\n.chat__list .chat__inneritems .custom-payload-con {\r\n  padding: 10px 15px;\r\n  border-radius: 5px;\r\n}\r\n\r\n.chat__body__btn em {\r\n  font-size: 27px;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n@media all and (min-width: 1900px) {\r\n  .chat__list .chat__inneritems .custom-payload-con {\r\n    padding: 15px 30px;\r\n    border-radius: 10px;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 2500px) {\r\n  .chat__list .chat__inneritems .custom-payload-con {\r\n    padding: 20px 30px;\r\n    border-radius: 12px;\r\n  }\r\n\r\n  .chat__body__btn em {\r\n    font-size: 35px;\r\n  }\r\n\r\n  .chat__body__btn em.customfontsize {\r\n    font-size: 40px !important;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 3800px) {\r\n  .chat__list .chat__inneritems .custom-payload-con {\r\n    padding: 40px 50px;\r\n    border-radius: 15px;\r\n  }\r\n\r\n  .chat__body__btn em {\r\n    font-size: 35px;\r\n  }\r\n\r\n  .chat__body__btn em.customfontsize {\r\n    font-size: 40px !important;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 1900px) {\r\n  #chatBodySec2 .chat__body__btn__title {\r\n    font-size: 13px;\r\n  }\r\n\r\n  #chatBodySec2 .chat__grid .chat__inneritems .chat__body__btn__title {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .chat__list .chat__inneritems .chat__body__btn {\r\n    min-height: 40px;\r\n  }\r\n\r\n  .chat__list .chat__inneritems .icon__cont__box {\r\n    margin: 0 20px 0 0;\r\n  }\r\n\r\n  .chat__list .chat__inneritems .icon__cont__box .icon__cont {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .chat__list .chat__inneritems .icon__cont__box .end__chatIcon {\r\n    width: 24px;\r\n  }\r\n\r\n  #chatBodySec2 .chat__list .chat__inneritems .chat__body__btn__title {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .chat__grid .chat__inneritems .icon__cont__box .icon__cont {\r\n    font-size: 22px;\r\n  }\r\n\r\n  .chat__grid .chat__inneritems .icon__cont__box .end__chatIcon {\r\n    width: 22px;\r\n  }\r\n\r\n  .img-max-height {\r\n    height: 35px;\r\n  }\r\n\r\n  .fullfill__columns .chat__grid {\r\n    gap: 15px;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 2500px) {\r\n  #chatBodySec2 .chat__body__btn__title {\r\n    font-size: 18px;\r\n  }\r\n\r\n  #chatBodySec2 .chat__grid .chat__inneritems .chat__body__btn__title {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .chat__grid .chat__inneritems .chat__body__btn {\r\n    min-height: 100px;\r\n  }\r\n\r\n  .chat__list .chat__inneritems .chat__body__btn {\r\n    min-height: 50px;\r\n  }\r\n\r\n  .chat__list .chat__inneritems .icon__cont__box {\r\n    margin: 0 20px 0 0;\r\n  }\r\n\r\n  .chat__list .chat__inneritems .icon__cont__box .icon__cont {\r\n    font-size: 36px;\r\n  }\r\n\r\n  .chat__list .chat__inneritems .icon__cont__box .end__chatIcon {\r\n    width: 36px;\r\n  }\r\n\r\n  #chatBodySec2 .chat__list .chat__inneritems .chat__body__btn__title {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .chat__grid .chat__inneritems .icon__cont__box .icon__cont {\r\n    font-size: 28px;\r\n  }\r\n\r\n  .chat__grid .chat__inneritems .icon__cont__box .end__chatIcon {\r\n    width: 28px;\r\n  }\r\n\r\n  .chat__body__btn em {\r\n    font-size: 35px;\r\n  }\r\n\r\n  .chat__body__btn em.customfontsize {\r\n    font-size: 40px !important;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 3800px) {\r\n  #chatBodySec2 .chat__body__btn__title {\r\n    font-size: 24px;\r\n  }\r\n\r\n  #chatBodySec2 .chat__grid .chat__inneritems .chat__body__btn__title {\r\n    font-size: 30px;\r\n  }\r\n\r\n  .chat__grid .chat__inneritems .chat__body__btn {\r\n    min-height: 160px;\r\n  }\r\n\r\n  .chat__list .chat__inneritems .chat__body__btn {\r\n    min-height: 60px;\r\n  }\r\n\r\n  .chat__list .chat__inneritems .icon__cont__box {\r\n    margin: 0 30px 0 0;\r\n  }\r\n\r\n  .chat__list .chat__inneritems .icon__cont__box .icon__cont {\r\n    font-size: 42px;\r\n  }\r\n\r\n  .chat__list .chat__inneritems .icon__cont__box .end__chatIcon {\r\n    width: 42px;\r\n  }\r\n\r\n  #chatBodySec2 .chat__list .chat__inneritems .chat__body__btn__title {\r\n    font-size: 30px;\r\n  }\r\n\r\n  .chat__grid .chat__inneritems .icon__cont__box {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .chat__grid .chat__inneritems .icon__cont__box .icon__cont {\r\n    font-size: 42px;\r\n  }\r\n\r\n  .chat__grid .chat__inneritems .icon__cont__box .end__chatIcon {\r\n    width: 42px;\r\n  }\r\n\r\n  .chat__body__btn em {\r\n    font-size: 35px;\r\n  }\r\n\r\n  .chat__body__btn em.customfontsize {\r\n    font-size: 40px !important;\r\n  }\r\n}\r\n\r\n.text_us_option {\r\n  padding: 5px 30px 20px 30px;\r\n}\r\n\r\n.text_us_card {\r\n  /* border: 1px solid #eee; */\r\n  border-radius: 5px;\r\n  padding: 13px 10px;\r\n  cursor: pointer;\r\n  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.09);\r\n}\r\n\r\n.text_us_card img {\r\n  height: 34px;\r\n}\r\n\r\n.or_section {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.text_us_option span {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: #000;\r\n}\r\n\r\n.text_us_option .text_us_card span {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 250px;\r\n  display: block;\r\n}\r\n\r\n.text_us_option .or_section span {\r\n  font-size: 13px;\r\n}\r\n\r\ndiv[disabled=true] {\r\n  opacity: 0.6;\r\n  pointer-events: none;\r\n}\r\n\r\n@media all and (min-width: 1900px) {\r\n  .text_us_option span {\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    color: #000;\r\n  }\r\n\r\n  .text_us_card img {\r\n    height: 50px;\r\n  }\r\n\r\n  .text_us_option {\r\n    padding: 5px 30px 20px 30px;\r\n  }\r\n\r\n  .chat__grid .custom-payload-con {\r\n    padding: 15px 2px !important;\r\n  }\r\n\r\n  .text_us_card {\r\n    padding: 16px 10px;\r\n  }\r\n\r\n  .chat__body__btn em {\r\n    font-size: 27px;\r\n    margin-bottom: 3px;\r\n  }\r\n\r\n  .chat__body__btn em.customfontsize {\r\n    font-size: 30px !important;\r\n    margin-bottom: 3px;\r\n  }\r\n\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
